import React, { useState } from "react";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Box,
  TextField,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "antd";

const MultiSelect = ({ label, options = [], value = [], onChange, helperText }) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [localValue, setLocalValue] = useState(value || []);

  const handleOpen = () => {
    setLocalValue(value || []);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSearchTerm("");
    onChange(localValue);
  };

  const handleChange = (event) => {
    const selected = event.target.value;
    if (selected.includes("all")) {
      setLocalValue(
        localValue?.length === options?.length
          ? []
          : options?.map((option) => option._id)
      );
    } else {
      setLocalValue(selected);
    }
  };

  const filteredOptions = options?.filter((option) =>
    option?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const currentValue = open ? localValue : (value || []);

  const isAllSelected =
    options?.length > 0 && currentValue?.length === options?.length;

  return (
    <FormControl fullWidth>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        multiple
        value={currentValue}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        onChange={handleChange}
        MenuProps={{
          autoFocus: false,
          PaperProps: { sx: { maxHeight: 360 } },
        }}
        renderValue={(selected) =>
          options
            ?.filter((option) => selected?.includes(option._id))
            .map((option) => option.title)
            .join(", ")
        }
      >
        <Box
          sx={{ p: 1, position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 1 }}
          onClick={(e) => e.stopPropagation()}
        >
          <TextField
            size="small"
            placeholder="Search..."
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <MenuItem value="all">
          <Checkbox checked={isAllSelected} />
          <ListItemText primary="Select All" />
        </MenuItem>
        {filteredOptions?.map((option) => (
          <MenuItem key={option._id} value={option._id}>
            <Checkbox checked={currentValue?.includes(option._id)} />
            <ListItemText primary={option.title} />
          </MenuItem>
        ))}
        <Box display="flex" justifyContent="flex-end" p={1}>
          <Button variant="contained" size="small" onClick={handleClose}>
            OK
          </Button>
        </Box>
      </Select>
      {/* component="div": helperText may be a <Typography> (a <p>), and
          FormHelperText is a <p> by default — <p> inside <p> is invalid. */}
      {helperText && (
        <FormHelperText error component="div">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default MultiSelect;
